/* eslint-disable no-unused-vars */
import $ from "jquery";

export default class LegacyCheckout {
    constructor() {
        if (document.getElementById("billing_invoice").checked) {
            document
                .getElementById("billing_invoice_company_field")
                .classList.remove("hidden-field");
            document
                .getElementById("billing_invoice_address_field")
                .classList.remove("hidden-field");
            document
                .getElementById("billing_invoice_postcode_field")
                .classList.remove("hidden-field");
            document
                .getElementById("billing_invoice_city_field")
                .classList.remove("hidden-field");
        }
        document
            .getElementById("billing_invoice")
            .addEventListener("change", (evt) => {
                if (evt.target.checked) {
                    document
                        .getElementById("billing_invoice_company_field")
                        .classList.remove("hidden-field");
                    document
                        .getElementById("billing_invoice_address_field")
                        .classList.remove("hidden-field");
                    document
                        .getElementById("billing_invoice_postcode_field")
                        .classList.remove("hidden-field");
                    document
                        .getElementById("billing_invoice_city_field")
                        .classList.remove("hidden-field");
                } else {
                    document
                        .getElementById("billing_invoice_company_field")
                        .classList.add("hidden-field");
                    document
                        .getElementById("billing_invoice_address_field")
                        .classList.add("hidden-field");
                    document
                        .getElementById("billing_invoice_postcode_field")
                        .classList.add("hidden-field");
                    document
                        .getElementById("billing_invoice_city_field")
                        .classList.add("hidden-field");
                }
            });
        this.cookie = window.cookie.get();

        $("#billing_first_name_field").before(
            '<p class="form-row form-row-first" id="billing_address_info">'
        );
        if (this.cookie.area && this.cookie.area.type === "pickup") {
            document
                .getElementById("billing_address_1_field")
                .classList.add("form-row-first");
            document
                .getElementById("billing_address_1_field")
                .classList.remove("form-row-wide");
            document.getElementById("billing_city_field").style.display =
                "block";
            document.getElementById("billing_postcode_field").style.display =
                "block";
            document.getElementById("billing_address_1_field").style.display =
                "block";
            document.getElementById("billing_lat").value = "0";
            document.getElementById("billing_lon").value = "0";
            document.getElementById("billing_address_2").value = "";
            document.getElementById("billing_address_2").readOnly = true;
            $("#billing_address_info")
                .text(
                    "Dein Salat wird im Store " +
                        (this.cookie.area.store_id === 1
                            ? "Essen"
                            : "Dortmund") +
                        " zur Abholung bereitstehen"
                )
                .append('<span id="checkout-change-delivery">ändern</span>');
            $("#checkout-change-delivery").click((evt) => {
                window.location.href = "/warenkorb/?change-area=1";
            });
        } else {
            document.getElementById("billing_lat").value =
                this.cookie.location.lat;
            document.getElementById("billing_lon").value =
                this.cookie.location.lon;
            document.getElementById("billing_address_1").value =
                this.cookie.address.address +
                " " +
                this.cookie.address.housenumber;
            document.getElementById("billing_postcode").value =
                this.cookie.address.postcode;
            document.getElementById("billing_city").value =
                this.cookie.address.locality;
            document.getElementById("billing_address_1").readOnly = true;
            document.getElementById("billing_postcode").readOnly = true;
            document.getElementById("billing_city").readOnly = true;
            $("#billing_address_info")
                .text(
                    "Die Lieferung erfolgt an " +
                        document.getElementById("billing_address_1").value +
                        ", " +
                        document.getElementById("billing_postcode").value +
                        " " +
                        document.getElementById("billing_city").value +
                        " "
                )
                .append('<span id="checkout-change-delivery">ändern</span>');
            $("#checkout-change-delivery").click((evt) => {
                window.location.href = "/warenkorb/?change-area=1";
            });
        }

        document.getElementById("billing_lat").readOnly = true;
        document.getElementById("billing_lon").readOnly = true;
        document.getElementById("billing_store").value =
            this.cookie.area.store_id;
        document.getElementById("billing_area").value = this.cookie.area.id;
    }
}
